import React, { Component } from 'react';
import PropTypes from 'prop-types';
// import { connect } from 'react-redux';
// import { registerField, getFormSyncErrors } from 'redux-form';
import { formatName } from '../utils';


class NameInput extends Component {
  constructor(props) {
    super(props);

    this.handleToggleEdit = this.handleToggleEdit.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleUpdateName = this.handleUpdateName.bind(this);
    this.isValid = this.isValid.bind(this);

    this.state = {
      editing: false,
      firstName: '',
      familyName: '',
    };
  }

  componentWillReceiveProps(nextProps) {
    // console.log(this.props.rsvpType, nextProps.rsvpType);
    const { rsvpType, input: { value } } = this.props;
    const { editing } = this.state;
    if ((rsvpType === 'NO_RESPONSE' || rsvpType === 'DECLINED') && nextProps.rsvpType === 'ATTENDING') {
      if (!value.firstName && !value.familyName) {
        this.handleToggleEdit();
      }
    }
    if (rsvpType === 'ATTENDING' && nextProps.rsvpType === 'DECLINED') {
      if (editing && !value.firstName && !value.familyName) {
        this.handleToggleEdit();
      }
    }
  }

  handleToggleEdit() {
    const { input } = this.props;
    this.setState(prevState => ({
      editing: !prevState.editing,
      firstName: input.value.firstName,
      familyName: input.value.familyName,
    }));
  }

  handleChange(e) {
    const { name, value } = e.target;
    if (name === 'firstName') {
      this.setState({
        firstName: value
      });
    } else if (name === 'familyName') {
      this.setState({
        familyName: value
      });
    }
  }

  handleUpdateName(e) {
    e.preventDefault();
    const { input } = this.props;
    const { firstName, familyName } = this.state;
    const nextInput = { firstName, familyName };
    input.onChange(nextInput);
    this.setState({
      editing: false
    });
  }

  isValid() {
    const { firstName, familyName } = this.state;
    if (firstName && familyName) {
      return true;
    }
    return false;
  }

  render() {
    const { input, meta: { touched, error } } = this.props;
    const { editing, firstName, familyName } = this.state;
    return (
      <div>
        {editing ? (
          <div className="form-group edit-guest-name">
            <h4>Name</h4>
            <div className="margin-bottom">
              <div className="row">
                <div className="col-xs-6 col-sm-6 col-md-6">
                  <div className={`first-name${touched && error && error.firstName ? ' has-error' : ''}`}>
                    <input
                      name="firstName"
                      type="text"
                      value={firstName || ''}
                      className="form-control"
                      onChange={this.handleChange}
                      placeholder="First Name"
                    />
                    {(touched && error && error.firstName) && (
                      <span className="help-block">Required</span>
                    )}
                  </div>
                </div>
                <div className="col-xs-6 col-sm-6 col-md-6">
                  <div className={`last-name ${(touched && error && error.familyName) ? ' has-error' : ''}`}>
                    <input
                      name="familyName"
                      type="text"
                      value={familyName || ''}
                      className="form-control"
                      onChange={this.handleChange}
                      placeholder="Last Name"
                    />
                    {(touched && error && error.familyName) && (
                      <span className="help-block danger-text">Required</span>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="clearfix">
              <div className="pull-right">
                <a role="button" className="text-button margin-right-2x" onClick={this.handleToggleEdit}>cancel</a>
                <button className={`btn btn-primary${this.isValid() ? '' : ' disabled'}`} disabled={!this.isValid()} onClick={this.handleUpdateName}>Update</button>
              </div>
            </div>
          </div>
        ) : (
          <div className={`guest-name${touched && error && (error.firstName || error.familyName) ? ' has-error' : ''}`}>
            <h4 className={touched && error && (error.firstName || error.familyName) ? 'has-error' : ''}>
              <span>{formatName(input.value.firstName, input.value.familyName)}</span>
              <span className="edit-guest-name-icon" onClick={this.handleToggleEdit}>
                <i className="glyphicon glyphicon-pencil" />
              </span>
            </h4>
            {(touched && error && error.firstName) && (
              <span className="help-block">First Name Required</span>
            )}
            {(touched && error && error.familyName) && (
              <span className="help-block danger-text">Family Name Required</span>
            )}
          </div>
        )}
      </div>
    );
  }
}

NameInput.propTypes = {
  input: PropTypes.shape({}),
  meta: PropTypes.shape({
    error: PropTypes.shape({}),
    touched: PropTypes.bool,
  }),
  rsvpType: PropTypes.string,
};

export default NameInput;



/** WEBPACK FOOTER **
 ** ./src/components/PublicWebsite/pages/rsvpV2/RsvpForm/GuestFields/NameInput.jsx
 **/